/** 列表最近一次的筛选条件（地址查询串），编辑页「返回」时恢复，回到原来的页签、筛选与页码 */
export const LIST_SEARCH_STORAGE_KEY = 'swiftx_website_content_list_search';

export const rememberListSearch = (search: string): void => {
    try {
        window.sessionStorage.setItem(LIST_SEARCH_STORAGE_KEY, search);
    } catch {
        // 忽略
    }
};
